export class ToggleElModel {
  id: number;
  leftText?: string = '';
  rightText?: string = '';
  additionalRightText?: string = '';
  selected?: boolean = false;
  readonly?: boolean = false;


  constructor(id: number, leftText?: string, rightText?: string, additionalRightText?: string,
              selected?: boolean, readonly?: boolean) {
    this.id = id;
    this.leftText = leftText;
    this.rightText = rightText;
    this.additionalRightText = additionalRightText;
    this.selected = selected;
    this.readonly = readonly;
  }

  public static create(model: ToggleElModel) {
    return new ToggleElModel(model.id, model.leftText, model.rightText, model.additionalRightText, model.selected, model.readonly);
  }
}
